import { trigger } from '@gravityforms/utils';
import elements from './elements';
import state from './state';

/**
 * @function initElements
 * @description Initializes elements for the starting of the form.
 *
 * @since 1.0.0
 *
 */
const initElements = () => {
	// Initialize all elements.
	elements.fields.forEach( ( field ) => {
		field.classList.remove( 'active-step' );
		field.setAttribute( 'aria-hidden', 'true' );

		// Cancel all animations running, reset styles. Require requestAnimationFrame in case animations just started.
		requestAnimationFrame( () => {
			const animations = field.getAnimations();
			if ( ! animations.length ) {
				return;
			}

			animations.forEach( ( animation ) => {
				animation.cancel();
				field.style.opacity = '';
				field.style.transform = '';
			} );
		} );
	} );
};

/**
 * @function startForm
 * @description Starts the conversational form from the welcome screen.
 *
 * @since 1.0.0
 *
 */
export const startForm = () => {
	if ( ! elements.fields[ state.activeFieldIndex ] ) {
		return;
	}
	initElements();
	elements.fields[ state.activeFieldIndex ].classList.add( 'active-step' );
	trigger( {
		event: 'gfcf/conversational/navigate/next',
		native: false,
		data: {
			target: elements.fields[ state.activeFieldIndex ],
		},
	} );
};

/**
 * @function handleBeginClick
 * @description Handles the begin action (i.e. going into the first page).
 *
 * @since 1.0.0
 *
 */
const handleBeginClick = () => {
	initElements();
	trigger( {
		event: 'gfcf/conversational/navigate/welcome',
		native: false,
		data: {
			welcome: {
				onAnimateStart: () => {
					elements.welcomeScreen.classList.remove( 'active' );
				},
			},
			form: {
				onAnimateStart: () => {
					elements.fields[ state.activeFieldIndex ].classList.add( 'active-step' );
					elements.conversationalForm.style.opacity = '0';
					elements.conversationalForm.classList.add( 'active' );
				},
				firstField: elements.fields[ state.activeFieldIndex ],
			},
		},
	} );
};

/**
 * @function bindEvents
 * @description Adds all the events listeners.
 *
 * @since 1.0.0
 *
 */
const bindEvents = () => {
	if ( ! elements.buttons.begin ) {
		return;
	}

	elements.buttons.begin.addEventListener( 'click', handleBeginClick );
};

/**
 * @function init
 * @description Initializes conversational forms welcome screen.
 *
 * @since 1.0.0
 *
 */
const init = () => {
	if ( ! elements.welcomeScreen ) {
		startForm();
		return;
	}

	bindEvents();
};

export default init;
